<template>
  <canvas ref="canvas"
          @mousedown="startDrawing"
          @mousemove="draw"
          @mouseup="stopDrawing"
          @mouseleave="stopDrawing"
          @contextmenu.prevent="undo"
  ></canvas>
</template>

<script>
export default {
  name: "DrawCanvas",
  data(){
    return{
      ctx:"",
      isDrawing:false,
      lastX: 0,
      lastY: 0,
      history: []

    }
  },
  methods:{
    startDrawing(e) {
      // 只响应左键点击
      if (e.button !== 0) return;

      this.isDrawing = true;
      [this.lastX, this.lastY] = this.getMousePos(e);
      this.ctx.beginPath();
      this.ctx.moveTo(this.lastX, this.lastY);
    },
    draw(e) {
      if (!this.isDrawing) return;

      const [x, y] = this.getMousePos(e);

      this.ctx.lineWidth = 3;
      this.ctx.lineCap = 'round';
      this.ctx.strokeStyle = 'rgb(255, 195, 0)';
      this.ctx.lineTo(x, y);
      this.ctx.stroke();

      [this.lastX, this.lastY] = [x, y];
    },
    stopDrawing(e) {
      // 只响应左键松开
      if (e.button !== 0) return;

      if (this.isDrawing) {
        this.isDrawing = false;
        this.saveToHistory();
      }
    },
    getMousePos(e) {
      const rect = this.$refs.canvas.getBoundingClientRect();
      return [
        e.clientX - rect.left,
        e.clientY - rect.top
      ];
    },
    saveToHistory() {
      this.history.push(
          this.ctx.getImageData(0, 0, this.$refs.canvas.width, this.$refs.canvas.height)
      );
    },
    undo() {
      if (this.history.length > 1) {
        this.history.splice(this.history.length - 1, 1); // 移除最后一个元素
        this.$nextTick(()=>{
          this.ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height); // 清空画布
          const previousState = this.history[this.history.length - 1];
          this.ctx.putImageData(previousState, 0, 0);
        })
      } else if (this.history.length === 1) {
        this.clearCanvas();
      }
    },
    clearCanvas() {
      this.ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      this.history = [];
    }

  },
  mounted(){
    this.ctx = this.$refs.canvas.getContext('2d');
    const container = this.$refs.canvas.parentElement;
    this.$refs.canvas.width = container.clientWidth;
    this.$refs.canvas.height = container.clientHeight;
  },
  beforeUnmount(){
    console.log("销毁画布")
    this.clearCanvas()
  }

}
</script>

<style scoped>

</style>